import { fetchApi } from './apiClient';

export const aiChatApi = {
    /**
     * Send a query to the AI chat
     * @param {string} query - The user's message
     */
    chat: async (query) => {
        return await fetchApi('/user/aiChat', 'POST', { query });
    }
};
